import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.dom-collections.for-each";
import baustein from "baustein";
import _extend from "lodash/extend";
import rothko from "web/script/modules/rothko";
import analytics from "web/script/analytics/analytics";
import globals from "web/script/modules/globals";
import userProfiler from "web/script/modules/userprofiler";
import "web/script/components/save-for-later-button";
import "web/script/components/save-for-later-signup-prompt";
import "web/script/components/tracked-link";
var CLOSE_CROSS_SELECTOR = ".cart-summary__close-button";
var CHECKOUT_BUTTON_SELECTOR = ".cart-summary__cta--checkout";
export default baustein.register("cart-summary", {
  template: function template() {
    return import(
    /* webpackChunkName: "template-cart-summary" */
    "templates/modules/cart_summary.jinja");
  },
  defaultOptions: {
    show_close_cross: false,
    productAnalyticsData: null,
    checkStock: false
  },
  init: function init() {
    var _this = this;

    this.cartSummaryClient = new rothko.Rothko("modules/cart_summary", {
      cache: false
    });
    this.cartSummaryClient.on("data", function (event, data) {
      _this.updateOptions({
        productAnalyticsData: data.product_analytics_data
      });

      if (data.state == "oos_notification") {
        if (data.item && !userProfiler.hasSeenOOSNotification(data.item.product_id)) {
          // tell parent to persist display of this component
          _this.emit("oosItemFound");

          userProfiler.saveSeenOOSNotification(data.item.product_id);
        } else {
          // don't render
          return;
        }
      }

      _this.setRenderContext(_this.makeContext(data));
    });

    if (this.options.checkStock) {
      this.checkStock();
    } else {
      this.update();
    }
  },
  setupEvents: function setupEvents(add) {
    add("click", CLOSE_CROSS_SELECTOR, this.close);
    add("click", function (event) {
      return event.stopPropagation();
    });
    add("click", CHECKOUT_BUTTON_SELECTOR, this._onClickCheckoutButton);
  },

  /**
   * On options change, always re-render.
   */
  onOptionsChange: function onOptionsChange() {
    var context = this.getRenderContext();
    this.setRenderContext(context);
  },

  /**
   * Get the initial render context.
   *
   * We want the initial state to be 'loading'
   */
  getInitialRenderContext: function getInitialRenderContext() {
    return this.makeContext({
      state: "loading"
    });
  },

  /**
   * Returns the context to render the component.
   *
   * We want the component option 'show_close_cross' to over-write the context provided
   * by the server since only the component can really know whether to show the close
   * cross or not.
   *
   * @param {Object} context The context from the server.
   */
  makeContext: function makeContext(context) {
    return {
      cart_summary: _extend(context, {
        show_close_cross: this.options.show_close_cross
      })
    };
  },

  /**
   * Shows the close cross
   */
  showCloseCross: function showCloseCross() {
    this.options.show_close_cross = true;
  },

  /**
   * Event handler for clicks on the close cross.
   */
  close: function close() {
    this.emit("closeIntent");
    this.options.show_close_cross = false;
  },

  /**
   * Fetch new data and re-render.
   */
  update: function update() {
    this.cartSummaryClient.fetch().catch(function () {});
  },

  /**
   * Like update(), but specifically for a stock check
   */
  checkStock: function checkStock() {
    this.cartSummaryClient.fetch({
      check_in_stock: true
    }).catch(function () {});
  },
  _onClickCheckoutButton: function _onClickCheckoutButton(event) {
    event.preventDefault();
    var href = event.target.href;
    (this.options.productAnalyticsData || []).forEach(function (product) {
      analytics.ecommerce("ec:addProduct", {
        name: product.product_canonical_slug,
        category: product.category,
        brand: product.designer_slug,
        variant: product.product_uid,
        price: product.price,
        quantity: 1,
        dimension20: product.gender,
        metric8: product.sale_discount
      });
    });
    analytics.ecommerce("ec:setAction", "checkout", {
      step: 1
    });
    analytics.event("CART_SUMMARY", "CHECKOUT").then(function () {
      globals.window.location = href;
    });
  }
});